import styled from "styled-components";
import { useParams } from "react-router-dom";
import * as Library from "../../../utils/Library";
import { useEffect } from "react";
import { useState } from "react";
import { formatOpeningHours, isStoreOpen } from "../../../utils/helperFunctions";
import CircluarLoader from "../../common/skeletons/CircluarLoader";

const StyledPage = styled.div`
    &.frame-1740095817,
    &.frame-1740095817 * {
        box-sizing: border-box;
    }
    &.frame-1740095817 {
        display: flex;
        flex-direction: column;
        gap: 40px;
        align-items: flex-start;
        justify-content: flex-start;
        position: relative;
        padding: 30px 32px;
        //height: 100%;

        min-height: calc(100dvh - 353px);
    }
    .frame-1740095792 {
        display: flex;
        flex-direction: column;
        gap: 30px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .follestad-stores {
        color: #f7665f;
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 24px;
        line-height: 24px;
        font-weight: 500;
        position: relative;
    }
    .frame-1740095816 {
        //display: flex;
        //flex-direction: row;

        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        flex-wrap: wrap;

        display: inline-grid;
        width: 100%;
        gap: 24px;
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    }
    .frame-1740095814 {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        //width: 446px;

        //min-width: 400px;
        flex-shrink: 1;
        flex-grow: 1;
        overflow: hidden;
        width: 100%;
    }
    .frame-1740095809 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        width: 446px;
    }
    .frame-1740095808 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .image {
        position: relative;
        width: 100%;
        height: 274px;
        overflow: hidden;
    }
    .image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .gradient-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background: linear-gradient(180.05deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
    }
    .frame-1740095812 {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        position: absolute;
        left: 0px;
        bottom: 0px;
    }
    .open-now {
        color: var(--color-emphasis, #9cf9cf);
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 13px;
        line-height: 24px;
        font-weight: 500;
        position: relative;
    }
    .frame-1740095815 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .follestad-bogstadvein {
        color: #ffffff;
        text-align: center;
        font-family: "ITC Avant Garde Gothic";
        font-size: 24px;
        line-height: 24px;
        font-weight: 500;
        position: relative;
        align-self: stretch;
    }
    .bogstadveien-6-0355-oslo-norway {
        color: #f3ede7;
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 16px;
        line-height: 18px;
        font-weight: 400;
        position: relative;
    }
    .frame-1740095804 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1740095803 {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1740095811 {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1740095801 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .monday {
        color: #f3ede7 !important;
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        position: relative;
        text-transform: capitalize;
    }
    .closed {
        color: #f3ede7 !important;
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        position: relative;
    }
    .closed-store {
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 13px;
        line-height: 24px;
        font-weight: 500;
        position: relative;
        color: red;
    }
    .no-stores-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 200px;
    }
    .text {
        font-size: 24px;
        font-weight: 500;
    }
`;

export default function StoreSection({ handleGetRetailBrandData, setLoading, loading, isAtEnd }) {
    /* #region VARS */
    const [storesData, setStoresData] = useState([]);
    const [retailBrandName, setRetailBrandName] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const params = useParams();
    /* #endregion */

    /* #region METHODS */
    const getStoresbyRetailBrands = async (page = 1) => {
        setLoading(true);
        const payload = {
            retailBrandID: params?.retailBrandID || "",
            limit: 10,
            page
        };
        try {
            const response = await Library.makePostRequest("getRetailerStores", payload, false, false);
            const data = response?.data?.data;

            if (page === 1) {
                setStoresData(data?.stores?.result || []);
            } else {
                setStoresData(prev => {
                    const newData = data?.stores?.result || [];
                    return [...prev, ...newData];
                });
            }

            handleGetRetailBrandData(data?.retailBrand || {});
            setRetailBrandName(data?.retailBrand?.name || "");
            setTotalPages(data?.stores?.totalPages || 0);
        } catch (error) {
            return error;
        } finally {
            setLoading(false);
        }
    };
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        getStoresbyRetailBrands();
    }, []);

    useEffect(() => {
        if (isAtEnd && !loading && currentPage < totalPages) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            getStoresbyRetailBrands(nextPage);
        }
    }, [isAtEnd, loading, currentPage, totalPages]);
    /* #endregion */

    return (
        <StyledPage className="frame-1740095817">
            {loading ? (
                <CircluarLoader />
            ) : (
                <>
                    <div className="frame-1740095792">
                        <div className="follestad-stores">{retailBrandName} stores</div>
                    </div>
                    <div className="frame-1740095816">
                        {storesData?.length === 0 && (
                            <div className="no-stores-container">
                                <p className="text">Hmmm, no stores found. Please try again later.</p>
                            </div>
                        )}
                        {storesData?.map((store, index) => {
                            const openingHours = formatOpeningHours(store?.openHours);
                            const data = isStoreOpen({ storeInformation: store });
                            return (
                                <div className="frame-1740095814" key={index}>
                                    <div className="frame-1740095809">
                                        <div className="frame-1740095808">
                                            <div className="image">
                                                <img
                                                    className="image"
                                                    src={store?.pictureURL?.replaceAll(" ", "%20") || ""}
                                                    alt={`store_${index}`}
                                                />
                                                <div className="gradient-overlay"></div>
                                            </div>
                                            <div className="frame-1740095812">
                                                <div className={data?.isOpen ? "open-now" : "closed-store"}>
                                                    {data?.isOpen ? "Open now" : "Closed"}{" "}
                                                </div>
                                                <div className="frame-1740095815">
                                                    <div className="follestad-bogstadvein">{store?.name || "Store Name"}</div>
                                                    <div className="bogstadveien-6-0355-oslo-norway">
                                                        {store?.address || "Store Address"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="frame-1740095804">
                                            <div className="frame-1740095803">
                                                <div className="frame-1740095811">
                                                    {openingHours?.map(({ day, time }, idx) => (
                                                        <div className="frame-1740095801" key={`${index}-${idx}`}>
                                                            <div className="monday">{day}</div>
                                                            <div className="closed">{time}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}
        </StyledPage>
    );
}
